// extracted by mini-css-extract-plugin
module.exports = {"headerFontFamily":"ColumnsChooserMenu_headerFontFamily__pBzVV","subtitle2":"ColumnsChooserMenu_subtitle2__1uU4-","input":"ColumnsChooserMenu_input__1HGDQ"};